import { RefObject, memo, useEffect, useState } from "react";

import { ChevronDown } from "lucide-react";

interface GoDownBtnProps {
	amount: number;
	scrollToElement: () => void;
	isShow: boolean;
	isBlocked: boolean;
	messageBoxFormRef: RefObject<HTMLDivElement | null>;
}
export const GoDownBtn = memo(({ amount, scrollToElement, isShow, isBlocked, messageBoxFormRef }: GoDownBtnProps) => {
	const max_amount = 99;
	const [height, setHeight] = useState(66);

	useEffect(() => {
		if (!messageBoxFormRef) return;

		const resizeObserver = new ResizeObserver((entries) => {
			for (const entry of entries) {
				if (entry.target === messageBoxFormRef.current) {
					setHeight(entry.contentRect.height);
				}
			}
		});

		if (messageBoxFormRef.current) {
			resizeObserver.observe(messageBoxFormRef.current);
		}

		return () => {
			if (messageBoxFormRef && messageBoxFormRef.current) {
				resizeObserver.unobserve(messageBoxFormRef.current);
			}
		};
	}, [messageBoxFormRef?.current]);

	return (
		<div
			className="absolute right-6.5 cursor-pointer"
			onClick={scrollToElement}
			style={{
				opacity: isShow ? 1 : 0,
				bottom: isBlocked ? 105 : height + 10,
			}}
		>
			{amount > 0 ? (
				<div className="absolute bottom-7 left-[4.5px] flex h-6 w-6 items-center justify-center rounded-full bg-primary">
					<span className="font-[Inter] text-xs leading-4.25 font-bold text-white">
						{amount >= max_amount ? max_amount : amount}
					</span>
				</div>
			) : null}

			<div className="flex size-8.5 items-center justify-center rounded-full bg-[#453e48]">
				<ChevronDown color="white" />
			</div>
		</div>
	);
});
